<template>
  <div class="partner-unos forma-erp">

    <!-- Traka drzi gumbe nadohvat i pokazuje kako ce partner izgledati. -->
    <div class="traka-ekrana mb-3">
      <div class="naslov">
        <span v-if="$store.state.editItem === 1">{{ lang.PartnerEdit }}</span>
        <span v-else>{{ lang.PartnerCreate }}</span>
      </div>
      <div class="brojka">
        <span>{{ bezZvjezdice(lang.PartnerName) }}</span>
        <b>{{ partner.partnerName ? partner.partnerName : '—' }}</b>
      </div>
      <div class="brojka">
        <span>{{ bezZvjezdice(lang.PartnerVATID) }}</span>
        <b>{{ partner.partnerVATID ? partner.partnerVATID : (partner.privatePerson ? lang.PartnerNotRequired : '—') }}</b>
      </div>
      <v-spacer></v-spacer>
      <v-progress-circular v-if="saving" indeterminate color="primary" size="22" class="mr-3"></v-progress-circular>
      <v-btn small outlined color="primary" class="mr-2" @click="partnerList">{{ langC.Back }}</v-btn>
      <v-btn small class="green white--text" :disabled="!formIsValid" @click="register">
        <span v-if="$store.state.language == 'EN'">Register partner</span>
        <span v-if="$store.state.language == 'HR'">Zapamti partnera</span>
      </v-btn>
    </div>

    <v-row no-gutters>
      <!-- ---------- lijevo: tko je partner ---------- -->
      <v-col cols="12" md="6" class="pr-md-2">

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">
            {{ lang.BasicData }}
            <span class="dodatak">{{ lang.PartnerRequiredFields }}</span>
            <v-spacer></v-spacer>
            <!-- Dohvat iz sudskog registra: naziv i adresa se ne prepisuju
                 rucno s interneta. Obrt i fizicka osoba se i dalje upisuju
                 rukom - njih u registru nema. -->
            <v-btn text small color="primary" class="pa-0 text-none dohvat" @click="otvoriRegistar">
              <v-icon small left>mdi-database-search</v-icon>Dohvati iz sudskog registra
            </v-btn>
          </v-card-title>
          <v-card-text class="tijelo">
            <!-- Privatnom kupcu OIB nije obavezan, poslovnom partneru jest. -->
            <v-checkbox
              v-model="partner.privatePerson"
              :label="lang.PartnerIsPrivate"
              hide-details
              dense
              class="mt-0 pt-0 mb-3"
            ></v-checkbox>

            <v-text-field
              :label="bezZvjezdice(lang.PartnerName) + ' *'"
              v-model="partner.partnerName"
              :rules="[required]"
              dense outlined hide-details class="mb-3"
            ></v-text-field>

            <v-row no-gutters>
              <v-col cols="12" sm="7" class="pr-2">
                <v-text-field
                  :label="bezZvjezdice(lang.PartnerNameShort)"
                  v-model="partner.partnerNameShort"
                  dense outlined hide-details class="mb-3"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="5">
                <v-text-field
                  :label="bezZvjezdice(lang.PartnerVATID) + (partner.privatePerson ? '' : ' *')"
                  v-model="partner.partnerVATID"
                  :rules="partner.privatePerson ? [] : [required]"
                  :hint="partner.privatePerson ? lang.PartnerVATIDNotRequired : ''"
                  :persistent-hint="partner.privatePerson"
                  dense outlined
                  :class="partner.privatePerson ? 'mb-1' : 'mb-3'"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" sm="8" class="pr-2">
                <v-text-field :label="lang.PartnerStreet" v-model="partner.partnerStreet" dense outlined hide-details class="mb-3"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field :label="lang.PartnerBuildingNameNumber" v-model="partner.partnerBuildingNameNumber" dense outlined hide-details class="mb-3"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="4" class="pr-2">
                <v-text-field :label="lang.PartnerPostcode" v-model="partner.partnerPostcode" dense outlined hide-details class="mb-3"></v-text-field>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field :label="lang.PartnerCity" v-model="partner.partnerCity" dense outlined hide-details class="mb-3"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="6" class="pr-2">
                <v-text-field :label="lang.PartnerCountyRegion" v-model="partner.partnerCountyRegion" dense outlined hide-details class="mb-3"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field :label="lang.PartnerStateLabel" v-model="partner.partnerState" dense outlined hide-details class="mb-3"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="7" class="pr-2">
                <v-text-field :label="lang.Partneremail" v-model="partner.partneremail" dense outlined hide-details class="mb-1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="5">
                <v-text-field :label="lang.PartnerPhones" v-model="partner.partnerPhones" dense outlined hide-details class="mb-1"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">{{ lang.PartnerFlags }}</v-card-title>
          <v-card-text class="tijelo">
            <div class="kvacice">
              <v-checkbox v-model="partner.specialCustomer" :label="lang.specialCustomer" hide-details dense class="mt-0 pt-0"></v-checkbox>
              <v-checkbox v-model="partner.Activ" :label="lang.PartnerActiv" hide-details dense class="mt-0 pt-0"></v-checkbox>
              <v-checkbox v-model="partner.partnerVATonPay" :label="lang.PartnerVATonPay" hide-details dense class="mt-0 pt-0"></v-checkbox>
              <v-checkbox v-model="partner.partnerRetail" :label="lang.PartnerRetail" hide-details dense class="mt-0 pt-0"></v-checkbox>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="direktorOtvoren = !direktorOtvoren">
            {{ lang.PartnerCEO }}
            <v-spacer></v-spacer>
            <v-icon small>{{ direktorOtvoren ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="direktorOtvoren">
            <v-row no-gutters>
              <v-col cols="12" sm="6" class="pr-2"><v-text-field :label="lang.PartnerDirectorFirst" v-model="partner.partnerDirectorFirst" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="6"><v-text-field :label="lang.PartnerDirectorLast" v-model="partner.partnerDirectorLast" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-text-field :label="lang.PartnerDirectorBusinessOccupation" v-model="partner.partnerDirectorBusinessOccupation" dense outlined hide-details class="mb-3"></v-text-field>
            <v-row no-gutters>
              <v-col cols="12" sm="7" class="pr-2"><v-text-field :label="lang.PartnerDirectorEmail" v-model="partner.partnerDirectorEmail" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="5"><v-text-field :label="lang.PartnerDirectorPhone" v-model="partner.partnerDirectorPhone" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="8" class="pr-2"><v-text-field :label="lang.PartnerStreet" v-model="partner.partnerDirectorAdressStreet" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="4"><v-text-field :label="lang.PartnerBuildingNameNumber" v-model="partner.partnerDirectorAdressBuildingNameNumber" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="4" class="pr-2"><v-text-field :label="lang.PartnerPostcode" v-model="partner.partnerDirectorPostcode" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="8"><v-text-field :label="lang.PartnerCity" v-model="partner.partnerDirectorCity" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="6" class="pr-2"><v-text-field :label="lang.PartnerCountyRegion" v-model="partner.partnerDirectorCountyRegion" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="6"><v-text-field :label="lang.PartnerDirectorStateResidence" v-model="partner.partnerDirectorStateResidence" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="4" class="pr-2"><v-text-field :label="lang.PartnerDirectorNationality" v-model="partner.partnerDirectorNationality" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="4" class="pr-2"><v-text-field :label="lang.PartnerDirectorTitle" v-model="partner.partnerDirectorTitle" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="4"><v-text-field :label="lang.PartnerDirectorContactOption" v-model="partner.partnerDirectorContactOption" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="6" class="pr-2"><v-text-field :label="lang.PartnerDirectorDateOfBirth" v-model="partner.partnerDirectorDateOfBirth" type="date" dense outlined hide-details class="mb-1"></v-text-field></v-col>
              <v-col cols="12" sm="6"><v-text-field :label="lang.PartnerDirectorFormer" v-model="partner.partnerDirectorFormer" dense outlined hide-details class="mb-1"></v-text-field></v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="kontaktOtvoren = !kontaktOtvoren">
            {{ lang.PartnerSecretary }}
            <v-spacer></v-spacer>
            <v-icon small>{{ kontaktOtvoren ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="kontaktOtvoren">
            <v-row no-gutters>
              <v-col cols="12" sm="6" class="pr-2"><v-text-field :label="lang.PartnerSecretaryFirst" v-model="partner.partnerSecretaryFirst" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="6"><v-text-field :label="lang.PartnerSecretaryLast" v-model="partner.partnerSecretaryLast" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-text-field :label="lang.PartnerSecretaryBusinessOccupation" v-model="partner.partnerSecretaryBusinessOccupation" dense outlined hide-details class="mb-3"></v-text-field>
            <v-row no-gutters>
              <v-col cols="12" sm="7" class="pr-2"><v-text-field :label="lang.PartnerSecretaryEmail" v-model="partner.partnerSceretaryEmail" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="5"><v-text-field :label="lang.PartnerSecretaryPhone" v-model="partner.partnerSecretaryPhone" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="8" class="pr-2"><v-text-field :label="lang.PartnerStreet" v-model="partner.partnerSecretaryAdressStreet" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="4"><v-text-field :label="lang.PartnerBuildingNameNumber" v-model="partner.partnerSecretaryAdressBuildingNameNumber" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="4" class="pr-2"><v-text-field :label="lang.PartnerPostcode" v-model="partner.partnerSecretaryPostcode" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="8"><v-text-field :label="lang.PartnerCity" v-model="partner.partnerSecretaryCity" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="6" class="pr-2"><v-text-field :label="lang.PartnerCountyRegion" v-model="partner.partnerSecretaryCountyRegion" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="6"><v-text-field :label="lang.PartnerSecretaryStateResidence" v-model="partner.partnerSecretaryStateResidence" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="4" class="pr-2"><v-text-field :label="lang.PartnerSecretaryNationality" v-model="partner.partnerSecretaryNationality" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="4" class="pr-2"><v-text-field :label="lang.PartnerSecretaryTitle" v-model="partner.partnerSecretaryTitle" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="4"><v-text-field :label="lang.PartnerSecretaryContactOption" v-model="partner.partnerSecretaryContactOption" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="6" class="pr-2"><v-text-field :label="lang.PartnerSecretaryDateOfBirth" v-model="partner.partnerSecretaryDateOfBirth" type="date" dense outlined hide-details class="mb-1"></v-text-field></v-col>
              <v-col cols="12" sm="6"><v-text-field :label="lang.PartnerSecretaryFormer" v-model="partner.partnerSecretaryFormer" dense outlined hide-details class="mb-1"></v-text-field></v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- ---------- desno: kako se s njim posluje ---------- -->
      <v-col cols="12" md="6" class="pl-md-2">

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">{{ lang.PartnerBank }}</v-card-title>
          <v-card-text class="tijelo">
            <v-text-field :label="lang.PartnerBankIBAN" v-model="partner.partnerBankIBAN" dense outlined hide-details class="mb-3"></v-text-field>
            <v-row no-gutters>
              <v-col cols="12" sm="7" class="pr-2"><v-text-field :label="lang.PartnerBankName" v-model="partner.partnerBankName" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="5"><v-text-field :label="lang.PartnerBankSWIFT" v-model="partner.partnerBankSWIFT" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-text-field :label="lang.PartnerBankAddress" v-model="partner.partnerBankAddress" dense outlined hide-details class="mb-1"></v-text-field>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="postavkeOtvorene = !postavkeOtvorene">
            {{ lang.PartnerSettings }}
            <span class="dodatak">{{ lang.PartnerSettingsHint }}</span>
            <v-spacer></v-spacer>
            <v-icon small>{{ postavkeOtvorene ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="postavkeOtvorene">
            <v-row no-gutters>
              <v-col cols="12" sm="4" class="pr-2"><v-text-field :label="lang.PartnerInvoiceDefDays" v-model.number="partner.partnerInvoiceDefDays" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field></v-col>
              <v-col cols="12" sm="4" class="pr-2"><v-text-field :label="lang.PartnerInvoiceType" v-model="partner.partnerInvoiceType" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="4"><v-text-field :label="lang.PartnerInvoicePlace" v-model="partner.partnerInvoicePlace" dense outlined hide-details class="mb-3"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="4" class="pr-2"><v-text-field :label="lang.PartnerDefaultWarehouse" v-model.number="partner.partnerDefaultWarehouse" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field></v-col>
              <v-col cols="12" sm="4" class="pr-2"><v-text-field :label="lang.PartnerPrinterSize" v-model.number="partner.partnerPrinterSize" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field></v-col>
              <v-col cols="12" sm="4"><v-text-field :label="lang.PartnerInvoiceSpeed" v-model.number="partner.partnerInvoiceSpeed" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="6" class="pr-2"><v-text-field :label="lang.PartnerStartInvoiceNumber" v-model.number="partner.partnerStartInvoiceNumber" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field></v-col>
              <v-col cols="12" sm="6"><v-text-field :label="lang.PartnerStartBillNumber" v-model.number="partner.partnerStartBillNumber" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="6" class="pr-2"><v-text-field :label="lang.PartnerStartFrom" v-model="partner.StartFrom" type="date" dense outlined hide-details class="mb-3"></v-text-field></v-col>
              <v-col cols="12" sm="3" class="pr-2"><v-text-field :label="lang.PartnerLockedCredit" v-model.number="partner.lockedCredit" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field></v-col>
              <v-col cols="12" sm="3"><v-text-field :label="lang.PartnerlockedDebit" v-model.number="partner.lockedDebit" type="number" dense outlined hide-details class="mb-3 desno"></v-text-field></v-col>
            </v-row>
            <div class="podnaslov mt-2">{{ lang.otherSettings }}</div>
            <div class="kvacice">
              <v-checkbox v-model="partner.partnerUseRetailPrice" :label="lang.PartnerUseRetailPrice" hide-details dense class="mt-0 pt-0"></v-checkbox>
              <v-checkbox v-model="partner.partnerShowLastSaleBuyer" :label="lang.PartnerShowLastSaleBuyer" hide-details dense class="mt-0 pt-0"></v-checkbox>
              <v-checkbox v-model="partner.partnerShowWarehouseState" :label="lang.PartnerShowWarehouseState" hide-details dense class="mt-0 pt-0"></v-checkbox>
              <v-checkbox v-model="partner.partnerShowInputPrice" :label="lang.PartnerShowInputPrice" hide-details dense class="mt-0 pt-0"></v-checkbox>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="tekstoviOtvoreni = !tekstoviOtvoreni">
            {{ lang.PartnerTexts }}
            <v-spacer></v-spacer>
            <v-icon small>{{ tekstoviOtvoreni ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="tekstoviOtvoreni">
            <v-textarea :label="lang.PartnerInvoiceMemo" v-model="partner.partnerInvoiceMemo" rows="2" dense outlined hide-details class="mb-3"></v-textarea>
            <v-textarea :label="lang.PartnerInvoiceForeginMemo" v-model="partner.partnerInvoiceForeginMemo" rows="2" dense outlined hide-details class="mb-3"></v-textarea>
            <v-textarea :label="lang.PartnerDeliveryNoteMemo" v-model="partner.partnerDeliveryNoteMemo" rows="2" dense outlined hide-details class="mb-3"></v-textarea>
            <v-textarea :label="lang.PartnerDeliveryNoteForeginMemo" v-model="partner.partnerDeliveryNoteForeginMemo" rows="2" dense outlined hide-details class="mb-3"></v-textarea>
            <v-textarea :label="lang.PartnerInvoiceHint" v-model="partner.partnerInvoiceHint" rows="2" dense outlined hide-details class="mb-1"></v-textarea>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="putoviOtvoreni = !putoviOtvoreni">
            {{ lang.PartnerPaths }}
            <span class="dodatak">{{ lang.PartnerPathsHint }}</span>
            <v-spacer></v-spacer>
            <v-icon small>{{ putoviOtvoreni ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="putoviOtvoreni">
            <v-text-field :label="lang.PartnerInputFilesPath" v-model="partner.partnerInputFilesPath" dense outlined hide-details class="mb-3"></v-text-field>
            <v-text-field :label="lang.PartnerOutputFilesPath" v-model="partner.partnerOutputFilesPath" dense outlined hide-details class="mb-3"></v-text-field>
            <v-text-field :label="lang.PartnerTransferDataFilesPath" v-model="partner.partnerTransferDataFilesPath" dense outlined hide-details class="mb-1"></v-text-field>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <SudRegTrazilica ref="registar" @odabrana="izRegistra" />

    <v-snackbar v-model="snackbar" :timeout="timeout" :color="color">
      {{ text }}
      <v-btn color="pink" text @click="snackbar = false">{{ langC.Close }}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import PartnerService from '@/services/PartnerService'
import PartnerCompanyService from '@/services/PartnerCompanyService'
import SudRegTrazilica from './SudRegTrazilica'
import { popuni as popuniIzRegistra } from '@/snippets/sudregPopuna'
import langEn from './PartnerDescEN'
import langHr from './PartnerDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import { testLastUpdate, newUpdates } from '@/services/TestLastUpdate'

export default {
  name: 'partnercreate',
  components: { SudRegTrazilica },
  data () {
    return {
      direktorOtvoren: false,
      kontaktOtvoren: false,
      postavkeOtvorene: false,
      tekstoviOtvoreni: false,
      putoviOtvoreni: false,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      showDirector: false,
      showContact: false,
      snackbar: false,
      saving: false,
      text: '',
      timeout: 2000,
      color: 'green',
      menu: false,
      modal: false,
      modal1: false,
      dialog1: false,
      locError: null,
      msg: '',
      newPartner: {},
      partner: {
        CompanyId: 1,
        CompanyNameDatabase: '',
        BusinessYear: 0,
        UserId: 1,
        email: '',
        First: '',
        Last: '',
        partnerName: '',
        partnerNameShort: '',
        partnerNameDatabase: '',
        partnerBuildingNameNumber: '',
        partnerStreet: '',
        partnerCity: '',
        partnerPostcode: '',
        partnerCountyRegion: '',
        partnerState: '',
        partnerVATID: '',
        partneremail: '',
        partnerPhones: '',
        partnerBankName: '',
        partnerBankAddress: '',
        partnerBankIBAN: '',
        partnerBankSWIFT: '',
        partnerDirectorTitle: '',
        partnerDirectorFirst: '',
        partnerDirectorLast: '',
        partnerDirectorFormer: '',
        partnerDirectorStateResidence: '',
        partnerDirectorNationality: '',
        partnerDirectorDateOfBirth: '',
        partnerDirectorBusinessOccupation: '',
        partnerDirectorAdressBuildingNameNumber: '',
        partnerDirectorAdressStreet: '',
        partnerDirectorCity: '',
        partnerDirectorPostcode: '',
        partnerDirectorCountyRegion: '',
        partnerDirectorEmail: '',
        partnerDirectorPhone: '',
        partnerDirectorContactOption: '',
        partnerSecretaryTitle: '',
        partnerSecretaryFirst: '',
        partnerSecretaryLast: '',
        partnerSecretaryFormer: '',
        partnerSecretaryStateResidence: '',
        partnerSecretaryNationality: '',
        partnerSecretaryDateOfBirth: '',
        partnerSecretaryBusinessOccupation: '',
        partnerSecretaryAdressBuildingNameNumber: '',
        partnerSecretaryAdressStreet: '',
        partnerSecretaryCity: '',
        partnerSecretaryPostcode: '',
        partnerSecretaryCountyRegion: '',
        partnerSecretaryEmail: '',
        partnerSecretaryPhone: '',
        partnerSecretaryContactOption: '',
        partnerInvoiceMemo: '',
        partnerInvoiceForeginMemo: '',
        partnerDeliveryNoteMemo: '',
        partnerDeliveryNoteForeginMemo: '',
        partnerInvoiceDefDays: 15,
        partnerInvoicePlace: '',
        partnerInvoiceType: '',
        partnerInvoiceHint: '',
        partnerInvoiceSpeed: 1,
        partnerUseRetailPrice: false,
        partnerShowLastSaleBuyer: false,
        partnerShowWarehouseState: false,
        partnerShowInputPrice: false,
        partnerVATonPay: false,
        partnerRetail: false,
        partnerDefaultWarehouse: 1,
        partnerPrinterSize: 1,
        partnerInputFilesPath: '',
        partnerOutputFilesPath: '',
        partnerTransferDataFilesPath: '',
        partnerStartInvoiceNumber: 1,
        partnerStartBillNumber: 1,
        partnerType: 1,
        StartFrom: null,
        Activ: false,
        lockedCredit: false,
        lockedDebit: false,
        memberOfGroup: '',
        EnteredInDatabase: null,
        LastUpdateInDatabase: null,
        privatePerson: false,
        specialCustomer: false,
        FreeF1: 0,
        FreeF2: 0,
        FreeF3: 0,
        FreeF4: 0,
        FreeF5: 0,
        FreeF6: 0,
        LastUpdateBy: ''
      },
      required: (value) => !!value || 'Required.',
      error: '',
      lang: {},
      langC: {},
      mainQuery: {},
      haveItem: {},
      privateP: true
    }
  },
  async mounted () {
    try {
      this.locError = null
      if (this.$store.state.language === 'EN') {
        this.lang = langEn
        this.langC = commEn
      }
      if (this.$store.state.language === 'HR') {
        this.lang = langHr
        this.langC = commHr
      }
      this.privateP = this.$store.state.user ? this.$store.state.user.privatePartner : true
      if (this.$store.state.editItem === 1) {
        // this.privGroups = (await PartnerService.index()).data.groups
        // console.log('privgroups', this.privGroups)
        if (!this.privateP) {
          console.log('mijenjam partnera po ID', this.$store.state.partnerid)
          const dbPartner = await PartnerService.findbyid(this.$store.state.partnerid)
          this.partner = dbPartner.data.partner
        }
        if (this.privateP) {
           console.log('mijenjam partnera po OIBu', this.$store.state.partnerVATID)
          const dbPartner = await PartnerService.show(this.$store.state.partnerVATID)
          this.partner = dbPartner.data.partner
        }
      }
    } catch (error) {
      this.error = error
    }
  },
  methods: {
    tekst (vrijednost) {
      return vrijednost === null || vrijednost === undefined ? '' : String(vrijednost).trim()
    },
    // Nazivi u sifrarniku nose zvjezdicu; obavezna polja oznacavamo sami, jer
    // se za OIB mijenja ovisno o tome je li partner privatni kupac.
    bezZvjezdice (naziv) {
      return String(naziv || '').replace(/\s*\*\s*$/, '')
    },

    // Tvrtka se moze upisati i rukom; ovo je samo precica da se naziv i adresa
    // ne prepisuju s interneta. Otvara se s onim sto je vec upisano, pa se
    // najcesce odmah vidi trazena firma.
    otvoriRegistar () {
      this.$refs.registar.otvori(this.partner.partnerName || this.partner.partnerVATID)
    },

    /**
     * Odabrana firma iz sudskog registra.
     *
     * Prepisuje se sve sto registar zna, jer je korisnik sam otvorio tražilicu
     * i sam odabrao firmu. IBAN, telefon i kontakti se ne diraju - njih u
     * sudskom registru nema.
     */
    izRegistra (firma) {
      if (!firma) { return }
      popuniIzRegistra(this.partner, firma, true)
      this.partner.partnerVATID = firma.partnerVATID || this.partner.partnerVATID
      // Naziv za bazu se inace racuna tek kod spremanja; ovdje se popuni odmah
      // da se vidi sto ce biti zapisano.
      if (this.partner.partnerName) {
        this.partner.partnerNameDatabase = this.partner.partnerName.replace(/[\W_]/g, '')
      }
      const s = firma.sudreg || {}
      this.text = s.aktivan === false
        ? 'Firma je u sudskom registru označena kao neaktivna. Provjerite podatke.'
        : 'Podaci su iz sudskog registra. Provjerite ih prije spremanja.'
      this.color = s.aktivan === false ? 'orange' : 'blue'
      this.timeout = 6000
      this.snackbar = true
    },

    showOn1() {
      this.show1 = !this.show1
    },
    showOn2() {
      this.show2 = !this.show2
    },
    showOn3() {
      this.show3 = !this.show3
    },
    showOn4() {
      this.show4 = !this.show4
    },
    showOn5() {
      this.show5 = !this.show5
    },
    showOnDirector() {
      this.showDirector = !this.showDirector
    },
    showOnContact() {
      this.showContact = !this.showContact
    },
    async register () {
      this.saving = true
      try {
        this.locError = null
        if (this.$store.state.editItem === 0) {
          this.locError = null
          if (this.$store.state.user.id) {
            this.partner.UserId = this.$store.state.user.id
          }
          if (this.$store.state.user.email) {
            this.partner.email = this.$store.state.user.email
            this.partner.LastUpdateBy = this.$store.state.user.email
          }
          if (this.$store.state.companyid) {
            this.partner.CompanyId = this.$store.state.companyid
            this.mainQuery.CompanyId = this.$store.state.companyid
          }
          if (this.$store.state.companyName) {
            this.partner.CompanyNameDatabase = this.$store.state.companyName
          }
          if (this.$store.state.businessYear) {
            this.partner.BusinessYear = this.$store.state.businessYear
          }
          // if (!this.partner.partneremail) {
          //   this.locError = 'Error partner dot have email ! '
          // }
          if (this.partner.privatePerson === false) {
            if (!this.partner.partnerVATID) {
              this.locError = this.locError + this.lang.alertError1
            }
            if (this.partner.partnerVATID) {
              this.mainQuery.partnerVATID = this.partner.partnerVATID
            }
            // if (this.partner.partneremail) {
            //   this.mainQuery.partneremail = this.partner.partneremail
            // }
            if (!this.locError) {
              await PartnerService.check(this.mainQuery)
                .then(res => {
                  if (res.data.partner) {
                    this.haveItem = res.data.partner
                    this.locError = this.lang.PartnerErrorVAT + (this.haveItem.partnerName ? this.haveItem.partnerName : '')
                  }
                  if (res.data.partner2) {
                    this.haveItem = res.data.partner2
                    this.locError = this.lang.PartnerErroremail + (this.haveItem.partnerName ? this.haveItem.partnerName : '')
                  }                
                })
                .catch(err => {
                  this.error = err.data
                  this.locError = false
                })
            }
          }
          if (!this.locError) {
            const {data} = await PartnerService.post(this.partner)
            if (data.partner) {
              const newPrivatePartner = {}
              newPrivatePartner.CompanyId = data.partner.CompanyId
              newPrivatePartner.CompanyNameDatabase = data.partner.CompanyNameDatabase
              newPrivatePartner.BusinessYear = data.partner.BusinessYear
              newPrivatePartner.UserId = data.partner.UserId ? data.partner.UserId : ''
              newPrivatePartner.email = data.partner.email ? data.partner.email : ''
              newPrivatePartner.partnerId = data.partner.id ? data.partner.id : ''
              newPrivatePartner.partnerNameDatabase = data.partner.partnerNameDatabase ? data.partner.partnerNameDatabase : ''
              newPrivatePartner.partnerVATID = data.partner.partnerVATID ? data.partner.partnerVATID : ''
              await PartnerCompanyService.post(newPrivatePartner)
            }
            this.text = this.lang.alertOK1
            this.color = 'green'
            this.snackbar = true
            // await checkPartners(1)
            await newUpdates(2)
            await testLastUpdate()
            if (this.$store.state.partnerStore) {
              this.partners = this.$store.state.partnerStore
            }
          } else {
            this.text = this.locError
            this.color = 'red'
            this.snackbar = true
          }
        }
        if (this.$store.state.editItem === 1) {
            if (this.partner.privatePerson === false) {
              if (!this.partner.partnerVATID) {
                this.locError = this.locError + this.lang.alertError1
              }
            }
            if (!this.locError) {
              await PartnerService.put(this.partner)
              this.text = this.lang.alertOK2
              this.color = 'green'
              this.snackbar = true
              // await checkPartners(1)
              await newUpdates(2)
              await testLastUpdate()
              if (this.$store.state.partnerStore) {
                this.partners = this.$store.state.partnerStore
              }
            } else {
               this.text = this.locError
               this.color = 'red'
               this.snackbar = true
            }
          
        }
      } catch (error) {
        this.error = error
      }
      this.saving = false
    },
    async partnerList () {
      try {
        if (this.$store.state.editItem === 1) {
          this.$store.dispatch('seteditItem', 0)
        }
        await this.$router.push({
          name: 'partner'
        })
      } catch (err) {
        this.error = err
      }
    }
  },
  computed: {
    formIsValid () {
      const imaNaziv = this.tekst(this.partner.partnerName) !== ''
      // Privatnom kupcu OIB nije obavezan, poslovnom partneru jest.
      const imaOib = this.tekst(this.partner.partnerVATID) !== ''
      return imaNaziv && (this.partner.privatePerson === true || imaOib)
    }
  },
  watch: {
    'partner.partnerName' () {
      if (this.partner.partnerName) {
        this.partner.partnerNameDatabase =  this.partner.partnerName.replace(/[\W_]/g, '')
        this.partner.partnerNameShort = this.partner.partnerName
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.partner-unos { padding: 8px 12px; }


.partner-unos .naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1976d2;
  padding: 8px 16px;
  min-height: 0;
  gap: 8px;
}
.partner-unos .naslov-kartice .dodatak,
.partner-unos .podnaslov .dodatak {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
}
.partner-unos .naslov-kartice.sklopiva {
  cursor: pointer;
}
.partner-unos .tijelo {
  padding: 14px 16px 16px;
}
.partner-unos .podnaslov {
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.75);
  margin-bottom: 8px;
}
.partner-unos .desno >>> input {
  text-align: right;
}
.partner-unos .kvacice {
  display: flex;
  flex-wrap: wrap;
  gap: 22px;
}
</style>
